document.addEventListener('DOMContentLoaded', function () {
  const sidebar = document.querySelector('db-sidebar');

  if (!sidebar) return;

  const openClass = 'db-sidebar--open';
  const triggers = document.querySelectorAll('[data-db-sidebar-open]');
  const closeTargets = sidebar.querySelectorAll('[data-db-sidebar-close]');

  function openSidebar(event) {
    if (event) event.preventDefault();

    sidebar.classList.add(openClass);
    sidebar.setAttribute('aria-hidden', 'false');
    sidebar.removeAttribute('inert');
  }

  function closeSidebar(event) {
    if (event) event.preventDefault();

    sidebar.classList.remove(openClass);
    sidebar.setAttribute('aria-hidden', 'true');
    sidebar.setAttribute('inert', '');
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', openSidebar);
  });

  closeTargets.forEach(function (target) {
    target.addEventListener('click', closeSidebar);
  });

  sidebar.addEventListener('click', function (event) {
    if (event.target === sidebar) {
      closeSidebar(event);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      if (sidebar.classList.contains(openClass)) {
        closeSidebar(event);
      }
    }
  });

  /* Wallpaper calculator form */
  const form = document.querySelector('[data-db-calc-form]');
  if (form) {
    const MAX_DIMENSION_INCHES = 2400; // 200 ft guardrail for accidental oversized entries.
    const unitsToggle = form.querySelector('[data-db-calc-units-toggle]');
    const wallRowsContainer = form.querySelector('[data-db-calc-walls]');
    const addWallButton = form.querySelector('[data-db-calc-add-wall]');
    const heightWrapperIn = form.querySelector('[data-db-calc-height-wrapper-in]');
    const heightWrapperFtIn = form.querySelector('[data-db-calc-height-wrapper-ft-in]');
    const rollSelect = form.querySelector('[data-db-calc-roll-select]');
    const heightInput = form.querySelector('[data-db-calc-height]');
    const heightFeetInput = form.querySelector('[data-db-calc-height-ft]');
    const heightInchesInput = form.querySelector('[data-db-calc-height-in]');
    const addToCartButton = form.querySelector('[data-db-calc-add-to-cart]');
    let currentUnits = 'ft-in';
    let variantRolls = [];
    let currentRoll = null;
    let lastCalculatedRolls = 0;

    function isStrictNumeric(raw) {
      return /^-?\d+(\.\d+)?$/.test(raw);
    }

    function enforceDigitsOnlyInput(inputEl) {
      if (!inputEl) return;

      inputEl.addEventListener('keydown', function (event) {
        if (event.key === '-' || event.key === '+' || event.key === 'e' || event.key === 'E' || event.key === '.') {
          event.preventDefault();
        }
      });

      inputEl.addEventListener('input', function () {
        inputEl.value = String(inputEl.value || '').replace(/[^\d]/g, '');
      });
    }

    enforceDigitsOnlyInput(heightInput);
    enforceDigitsOnlyInput(heightFeetInput);
    enforceDigitsOnlyInput(heightInchesInput);

    function getWallRows() {
      return wallRowsContainer ? Array.prototype.slice.call(wallRowsContainer.querySelectorAll('[data-db-calc-wall-row]')) : [];
    }

    function applyDigitsOnlyToWallRow(row) {
      if (!row) return;
      enforceDigitsOnlyInput(row.querySelector('[data-db-calc-width]'));
      enforceDigitsOnlyInput(row.querySelector('[data-db-calc-width-ft]'));
      enforceDigitsOnlyInput(row.querySelector('[data-db-calc-width-in]'));
    }

    function renumberWallRows() {
      const rows = getWallRows();
      rows.forEach(function (row, index) {
        const sequence = index + 1;
        const label = row.querySelector('[data-db-calc-wall-label]');
        const removeButton = row.querySelector('[data-db-calc-remove-wall]');
        const inchesInput = row.querySelector('[data-db-calc-width]');
        const feetInput = row.querySelector('[data-db-calc-width-ft]');
        const inchPartInput = row.querySelector('[data-db-calc-width-in]');

        if (label) {
          label.textContent = 'Wall width ' + sequence;
          label.setAttribute('for', 'db-calc-width-ft-' + sequence);
        }
        if (inchesInput) {
          inchesInput.id = 'db-calc-width-' + sequence;
        }
        if (feetInput) {
          feetInput.id = 'db-calc-width-ft-' + sequence;
        }
        if (inchPartInput) {
          inchPartInput.id = 'db-calc-width-in-' + sequence;
        }
        if (removeButton) {
          removeButton.hidden = sequence === 1;
          removeButton.setAttribute('aria-label', 'Remove wall width ' + sequence);
        }
      });
    }

    function syncWallWidthVisibility() {
      const rows = getWallRows();
      const useInches = currentUnits === 'in';
      rows.forEach(function (row) {
        const rowWidthIn = row.querySelector('[data-db-calc-wall-width-wrapper-in]');
        const rowWidthFtIn = row.querySelector('[data-db-calc-wall-width-wrapper-ft-in]');
        if (rowWidthIn) rowWidthIn.hidden = !useInches;
        if (rowWidthFtIn) rowWidthFtIn.hidden = useInches;
      });
    }

    function addWallRow() {
      if (!wallRowsContainer) return;
      const rows = getWallRows();
      const templateRow = rows.length > 0 ? rows[0] : null;
      if (!templateRow) return;

      const clone = templateRow.cloneNode(true);
      const inputs = clone.querySelectorAll('input');
      inputs.forEach(function (input) {
        input.value = '';
      });

      wallRowsContainer.appendChild(clone);
      applyDigitsOnlyToWallRow(clone);
      renumberWallRows();
      syncWallWidthVisibility();
    }

    function removeWallRow(removeButton) {
      if (!wallRowsContainer || !removeButton) return;
      const rows = getWallRows();
      if (rows.length <= 1) return;
      const row = removeButton.closest('[data-db-calc-wall-row]');
      if (!row) return;

      row.remove();
      renumberWallRows();
      syncWallWidthVisibility();
    }

    getWallRows().forEach(function (row) {
      applyDigitsOnlyToWallRow(row);
    });
    renumberWallRows();
    syncWallWidthVisibility();

    if (addWallButton) {
      addWallButton.addEventListener('click', function () {
        addWallRow();
      });
    }
    if (wallRowsContainer) {
      wallRowsContainer.addEventListener('click', function (event) {
        const removeButton = event.target.closest('[data-db-calc-remove-wall]');
        if (!removeButton) return;
        event.preventDefault();
        removeWallRow(removeButton);
      });
    }

    function setAddToCartEnabled(enabled) {
      if (!addToCartButton) return;
      addToCartButton.disabled = !enabled;
    }

    function normalizeSizeText(value) {
      return String(value || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }

    function selectRollOptionByVariantId(variantId) {
      if (!rollSelect || !variantId) return false;
      const variantIdStr = String(variantId);
      for (let i = 0; i < rollSelect.options.length; i++) {
        if (rollSelect.options[i].value === variantIdStr) {
          rollSelect.value = variantIdStr;
          currentRoll = variantRolls.find(function (v) {
            return String(v.id) === variantIdStr;
          }) || null;
          return true;
        }
      }
      return false;
    }

    function selectRollOptionBySizeLabel(sizeLabel) {
      if (!rollSelect || !sizeLabel) return false;
      const target = normalizeSizeText(sizeLabel);

      for (let i = 0; i < rollSelect.options.length; i++) {
        const option = rollSelect.options[i];
        const optionText = normalizeSizeText(option.textContent);
        if (optionText === target || optionText.includes(target) || target.includes(optionText)) {
          rollSelect.value = option.value;
          currentRoll = variantRolls.find(function (v) {
            return String(v.id) === option.value;
          }) || null;
          return true;
        }
      }
      return false;
    }

    function getSelectedPdpSizeLabel() {
      const sizeContainers = document.querySelectorAll('[data-variant-picker-option-inputs][option-picker-name]');
      for (let i = 0; i < sizeContainers.length; i++) {
        const container = sizeContainers[i];
        const optionName = normalizeSizeText(container.getAttribute('option-picker-name'));
        if (optionName !== 'size') continue;

        const checkedInput = container.querySelector('input[type="radio"]:checked');
        if (checkedInput && checkedInput.value) {
          return String(checkedInput.value);
        }
      }
      return '';
    }

    function getSelectedPdpVariantId() {
      const variantInput = document.querySelector('[data-product-form-variant]');
      return variantInput && variantInput.value ? String(variantInput.value) : '';
    }

    function syncRollWithPdpSelection() {
      if (!rollSelect || rollSelect.options.length === 0) return;

      const selectedSize = getSelectedPdpSizeLabel();
      if (selectedSize && selectRollOptionBySizeLabel(selectedSize)) {
        return;
      }

      const selectedVariantId = getSelectedPdpVariantId();
      if (selectedVariantId && selectRollOptionByVariantId(selectedVariantId)) {
        return;
      }
    }

    function bindPdpRollSync() {
      // Initial sync on load.
      syncRollWithPdpSelection();

      // Sync when any PDP option radio changes.
      document.addEventListener('change', function (event) {
        const target = event.target;
        if (!(target instanceof HTMLInputElement)) return;
        if (target.type !== 'radio') return;
        syncRollWithPdpSelection();
      });

      // Sync when hidden selected variant ID changes.
      const variantInput = document.querySelector('[data-product-form-variant]');
      if (!variantInput) return;

      variantInput.addEventListener('change', function () {
        syncRollWithPdpSelection();
      });

      const observer = new MutationObserver(function () {
        syncRollWithPdpSelection();
      });
      observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });

      // Some themes update selected option state in variant-picker UI before/without
      // dispatching a direct change on the hidden variant input, so observe that subtree too.
      const variantPicker = document.querySelector('variant-picker');
      if (variantPicker) {
        const variantPickerObserver = new MutationObserver(function () {
          syncRollWithPdpSelection();
        });
        variantPickerObserver.observe(variantPicker, {
          subtree: true,
          childList: true,
          attributes: true,
          characterData: true
        });
      }

    }

    if (addToCartButton) {
      function refreshCartDrawerSection() {
        const currentCartDrawer = document.getElementById('CartDrawer');
        if (!currentCartDrawer) return Promise.resolve();

        const sectionId = currentCartDrawer.getAttribute('data-section-id');
        if (!sectionId) return Promise.resolve();

        return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId), {
          headers: { Accept: 'text/html' }
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Failed to fetch cart drawer section');
            return response.text();
          })
          .then(function (html) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const incomingCartDrawer = doc.getElementById('CartDrawer');
            if (!incomingCartDrawer) return;

            const liveCartDrawer = document.getElementById('CartDrawer');
            if (!liveCartDrawer) return;
            liveCartDrawer.replaceWith(incomingCartDrawer);

            // Re-open the drawer after replacing DOM so customers immediately see updates.
            const cartDrawerButtons = document.querySelectorAll('[data-sidebar-button][data-sidebar-id="CartDrawer"]');
            let openButton = null;
            for (let i = 0; i < cartDrawerButtons.length; i++) {
              if (!cartDrawerButtons[i].closest('#CartDrawer')) {
                openButton = cartDrawerButtons[i];
                break;
              }
            }
            if (openButton instanceof HTMLButtonElement) openButton.click();
          });
      }

      addToCartButton.addEventListener('click', function () {
        const errorEl = document.querySelector('[data-db-calc-error]');
        const resultEl = document.querySelector('[data-db-calc-result]');

        if (errorEl) errorEl.textContent = '';
        if (resultEl) resultEl.textContent = '';

        if (!lastCalculatedRolls || lastCalculatedRolls <= 0) {
          if (errorEl) {
            errorEl.textContent = 'Calculate first to add the recommended quantity to cart.';
          }
          return;
        }

        const selectedVariantId = rollSelect && rollSelect.value ? Number(rollSelect.value) : (currentRoll ? Number(currentRoll.id) : 0);
        if (!selectedVariantId) {
          if (errorEl) {
            errorEl.textContent = 'Select a roll size to add to cart.';
          }
          return;
        }

        addToCartButton.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: selectedVariantId,
            quantity: lastCalculatedRolls
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart add failed');
            return response.json();
          })
          .then(function () {
            return refreshCartDrawerSection().catch(function () {
              // Keep add-to-cart successful even if drawer refresh fails.
            });
          })
          .then(function () {
            if (resultEl) {
              resultEl.textContent = 'Added ' + lastCalculatedRolls + (lastCalculatedRolls === 1 ? ' roll' : ' rolls') + ' to cart.';
            }
          })
          .catch(function () {
            if (errorEl) {
              errorEl.textContent = 'Unable to add to cart right now. Please try again.';
            }
          })
          .finally(function () {
            addToCartButton.disabled = false;
          });
      });
    }

    const metaEl = document.querySelector('[data-db-product-meta]');
    if (metaEl) {
      const variantsJson = metaEl.getAttribute('data-db-variants');
      if (variantsJson) {
        try {
          variantRolls = JSON.parse(variantsJson);
        } catch (e) {
          // Liquid `escape` turns quotes into HTML entities; decode them before parsing.
          try {
            const textarea = document.createElement('textarea');
            textarea.innerHTML = variantsJson;
            const decoded = textarea.value;
            variantRolls = JSON.parse(decoded);
          } catch (e2) {
            console.warn('DbWallpaperCalculator: failed to parse variant metadata JSON', e, e2);
          }
        }
      }
    }

    if (rollSelect && Array.isArray(variantRolls) && variantRolls.length > 0) {
      rollSelect.innerHTML = '';

      // Shopify variants are the cartesian product of all options (e.g. Material × Size),
      // so we dedupe by the "Size" option to show only the unique roll sizes.
      const uniqueBySize = {};
      const uniqueSizeOrder = [];

      variantRolls.forEach(function (variant) {
        const rollWidth = Number(variant.roll_width) || 0;
        const rollLength = Number(variant.roll_length) || 0;

        const sizeKey = variant.size ? String(variant.size) : (variant.title ? String(variant.title) : String(variant.id));

        // Filter out non-roll options we don't want customers selecting.
        const sizeKeyLower = sizeKey.toLowerCase();
        if (sizeKeyLower === 'swatch' || sizeKeyLower.startsWith('swatch ') || sizeKeyLower.includes('swatch')) return;
        if (sizeKeyLower === 'large sample' || sizeKeyLower.startsWith('large sample ') || sizeKeyLower.includes('large sample')) return;
        if (sizeKeyLower === 'small  sample' || sizeKeyLower.startsWith('small sample ') || sizeKeyLower.includes('small sample')) return;
        if (sizeKeyLower === 'wide sample' || sizeKeyLower.startsWith('wide sample ') || sizeKeyLower.includes('wide sample')) return;

        // Prefer the variant candidate that actually has roll metafields set.
        const candidateHasRollData = (rollWidth > 0 && rollLength > 0);
        const existing = uniqueBySize[sizeKey];
        const existingHasRollData = existing ? (Number(existing.roll_width) || 0) > 0 && (Number(existing.roll_length) || 0) > 0 : false;

        if (!existing) {
          uniqueBySize[sizeKey] = variant;
          uniqueSizeOrder.push(sizeKey);
        } else if (!existingHasRollData && candidateHasRollData) {
          uniqueBySize[sizeKey] = variant;
        }
      });

      // Render the dropdown options in the order the sizes appear.
      uniqueSizeOrder.forEach(function (sizeKey) {
        const variant = uniqueBySize[sizeKey];
        if (!variant) return;

        const rollWidth = Number(variant.roll_width) || 0;
        const rollLength = Number(variant.roll_length) || 0;

        const sizeLabel = variant.size ? String(variant.size) : variant.title ? String(variant.title) : String(variant.id);
        const rollLabel = rollWidth + '" × ' + rollLength + ' ft';  // variable for roll width and length

        // Always show the computed roll dimensions next to the "Size" label.
        // (e.g. "Wide Roll (50in x 33ft) – 50\" × 33 ft").
        const optionLabel = sizeLabel // + ' – ' + rollLabel; // this is where it's rendering roll width and length

        const option = document.createElement('option');
        option.value = String(variant.id);
        option.textContent = optionLabel;
        rollSelect.appendChild(option);
      });

      if (rollSelect.options.length > 0) {
        const firstValue = rollSelect.options[0].value;
        currentRoll = variantRolls.find(function (v) {
          return String(v.id) === firstValue;
        }) || null;
      }

      rollSelect.addEventListener('change', function () {
        const selectedId = rollSelect.value;
        currentRoll = variantRolls.find(function (v) {
          return String(v.id) === selectedId;
        }) || null;
      });

      bindPdpRollSync();
    }

    if (unitsToggle && heightWrapperIn && heightWrapperFtIn) {
      unitsToggle.addEventListener('click', function (event) {
        const button = event.target.closest('[data-db-calc-units-option]');
        if (!button) return;

        const value = button.getAttribute('data-db-calc-units-value');
        if (!value || value === currentUnits) return;

        currentUnits = value;

        const options = unitsToggle.querySelectorAll('[data-db-calc-units-option]');
        options.forEach(function (option) {
          const optionValue = option.getAttribute('data-db-calc-units-value');
          const isActive = optionValue === currentUnits;
          option.classList.toggle('db-calc-units-toggle__option--active', isActive);
          option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        const useInches = currentUnits === 'in';
        heightWrapperIn.hidden = !useInches;
        heightWrapperFtIn.hidden = useInches;
        syncWallWidthVisibility();
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      const errorEl = document.querySelector('[data-db-calc-error]');
      const resultEl = document.querySelector('[data-db-calc-result]');

      let wallWidthsInches = [];
      let wallHeight;
      let validationError = '';
      lastCalculatedRolls = 0;
      setAddToCartEnabled(false);

      if (errorEl) errorEl.textContent = '';
      if (resultEl) resultEl.textContent = '';

      if (currentUnits === 'ft-in') {
        const heightFeetRaw = heightFeetInput ? String(heightFeetInput.value || '').trim() : '';
        const heightInchesRaw = heightInchesInput ? String(heightInchesInput.value || '').trim() : '';
        const heightMissing = heightFeetRaw === '' && heightInchesRaw === '';
        if (heightMissing) {
          validationError = 'Enter wall height.';
        }

        const hasNonNumericFtInInput =
          (heightFeetRaw !== '' && !isStrictNumeric(heightFeetRaw)) ||
          (heightInchesRaw !== '' && !isStrictNumeric(heightInchesRaw));
        if (!validationError && hasNonNumericFtInInput) {
          validationError = 'Use numbers only for wall measurements.';
        }

        const wallHeightFeet = heightFeetRaw === '' ? 0 : parseFloat(heightFeetRaw, 10);
        const wallHeightInchesPart = heightInchesRaw === '' ? 0 : parseFloat(heightInchesRaw, 10);

        const heightInvalid =
          isNaN(wallHeightFeet) ||
          isNaN(wallHeightInchesPart) ||
          wallHeightFeet < 0 ||
          wallHeightInchesPart < 0;

        wallHeight =
          (isNaN(wallHeightFeet) ? 0 : wallHeightFeet * 12) +
          (isNaN(wallHeightInchesPart) ? 0 : wallHeightInchesPart);

        if (!validationError && heightInvalid) {
          validationError = 'Wall measurements cannot be negative.';
        }
        if (!validationError && wallHeight <= 0) {
          validationError = 'Wall height must be greater than 0.';
        }
        if (!validationError && wallHeight > MAX_DIMENSION_INCHES) {
          validationError = 'Entered dimensions are too large. Please double-check.';
        }

        if (!validationError) {
          const rows = getWallRows();
          rows.forEach(function (row) {
            if (validationError) return;
            const wallFeetInput = row.querySelector('[data-db-calc-width-ft]');
            const wallInchesInput = row.querySelector('[data-db-calc-width-in]');
            const wallFeetRaw = wallFeetInput ? String(wallFeetInput.value || '').trim() : '';
            const wallInchesRaw = wallInchesInput ? String(wallInchesInput.value || '').trim() : '';

            const wallMissing = wallFeetRaw === '' && wallInchesRaw === '';
            if (wallMissing) return;

            if (
              (wallFeetRaw !== '' && !isStrictNumeric(wallFeetRaw)) ||
              (wallInchesRaw !== '' && !isStrictNumeric(wallInchesRaw))
            ) {
              validationError = 'Use numbers only for wall measurements.';
              return;
            }

            const wallWidthFeet = wallFeetRaw === '' ? 0 : parseFloat(wallFeetRaw, 10);
            const wallWidthInchesPart = wallInchesRaw === '' ? 0 : parseFloat(wallInchesRaw, 10);
            if (
              isNaN(wallWidthFeet) ||
              isNaN(wallWidthInchesPart) ||
              wallWidthFeet < 0 ||
              wallWidthInchesPart < 0
            ) {
              validationError = 'Wall measurements cannot be negative.';
              return;
            }

            const wallWidth =
              (isNaN(wallWidthFeet) ? 0 : wallWidthFeet * 12) +
              (isNaN(wallWidthInchesPart) ? 0 : wallWidthInchesPart);

            if (wallWidth <= 0) {
              validationError = 'Each wall width must be greater than 0.';
              return;
            }
            if (wallWidth > MAX_DIMENSION_INCHES) {
              validationError = 'Entered dimensions are too large. Please double-check.';
              return;
            }

            wallWidthsInches.push(wallWidth);
          });
        }
      } else {
        const heightRaw = heightInput ? String(heightInput.value || '').trim() : '';

        if (heightRaw === '') {
          validationError = 'Enter wall height.';
        }
        if (!validationError && !isStrictNumeric(heightRaw)) {
          validationError = 'Use numbers only for wall measurements.';
        }

        wallHeight = heightRaw === '' ? NaN : parseFloat(heightRaw, 10);

        if (!validationError && isNaN(wallHeight)) {
          validationError = 'Use numbers only for wall measurements.';
        }
        if (!validationError && wallHeight < 0) {
          validationError = 'Wall measurements cannot be negative.';
        }
        if (!validationError && wallHeight <= 0) {
          validationError = 'Wall height must be greater than 0.';
        }
        if (!validationError && wallHeight > MAX_DIMENSION_INCHES) {
          validationError = 'Entered dimensions are too large. Please double-check.';
        }

        if (!validationError) {
          const rows = getWallRows();
          rows.forEach(function (row) {
            if (validationError) return;
            const wallInput = row.querySelector('[data-db-calc-width]');
            const widthRaw = wallInput ? String(wallInput.value || '').trim() : '';
            if (widthRaw === '') return;

            if (!isStrictNumeric(widthRaw)) {
              validationError = 'Use numbers only for wall measurements.';
              return;
            }

            const wallWidth = parseFloat(widthRaw, 10);
            if (isNaN(wallWidth)) {
              validationError = 'Use numbers only for wall measurements.';
              return;
            }
            if (wallWidth < 0) {
              validationError = 'Wall measurements cannot be negative.';
              return;
            }
            if (wallWidth <= 0) {
              validationError = 'Each wall width must be greater than 0.';
              return;
            }
            if (wallWidth > MAX_DIMENSION_INCHES) {
              validationError = 'Entered dimensions are too large. Please double-check.';
              return;
            }

            wallWidthsInches.push(wallWidth);
          });
        }
      }

      if (!validationError && wallWidthsInches.length === 0) {
        validationError = 'Enter at least one wall width.';
      }

      if (validationError) {
        if (errorEl) {
          errorEl.textContent = validationError;
        }
        return;
      }

      if (!currentRoll || !rollSelect || rollSelect.selectedIndex < 0) {
        if (errorEl) {
          errorEl.textContent = 'Select a roll size to calculate.';
        }
        return;
      }

      let selectedRollLabel = '';
      if (rollSelect && rollSelect.selectedIndex >= 0) {
        const selectedOption = rollSelect.options[rollSelect.selectedIndex];
        selectedRollLabel = selectedOption && selectedOption.textContent ? String(selectedOption.textContent) : '';
      }

      const payload = {
        wallWidthsInches: wallWidthsInches,
        wallHeightInches: wallHeight,
        rollData: currentRoll,
        rollLabel: selectedRollLabel
      };

      console.log('DbWallpaperCalculator inputs:', payload);
      try {
        const calculation = calculateWallpaper(payload);
        if (calculation && calculation.rollsNeeded > 0) {
          lastCalculatedRolls = calculation.rollsNeeded;
          setAddToCartEnabled(true);
        }
      } catch (calcError) {
        console.error('DbWallpaperCalculator: unexpected calculation failure.', calcError);
        if (errorEl) {
          errorEl.textContent = 'We could not calculate this right now. Please try again.';
        }
        setAddToCartEnabled(false);
      }
    });
  }

  function calculateWallpaper(inputs) {
    const resultEl = document.querySelector('[data-db-calc-result]');
    const errorEl = document.querySelector('[data-db-calc-error]');

    if (resultEl) {
      resultEl.textContent = '';
    }
    if (errorEl) {
      errorEl.textContent = '';
    }

    const wallWidthsInches = inputs && Array.isArray(inputs.wallWidthsInches)
      ? inputs.wallWidthsInches.filter(function (width) { return typeof width === 'number' && !isNaN(width); })
      : (inputs && typeof inputs.wallWidthInches === 'number' ? [inputs.wallWidthInches] : []);
    const wallHeight = inputs && typeof inputs.wallHeightInches === 'number' ? inputs.wallHeightInches : NaN;

    if (wallWidthsInches.length === 0 || isNaN(wallHeight) || wallHeight <= 0) {
      if (errorEl) {
        errorEl.textContent = 'Wall widths and height must be greater than 0.';
      }
      return null;
    }

    for (let i = 0; i < wallWidthsInches.length; i++) {
      if (wallWidthsInches[i] <= 0) {
        if (errorEl) {
          errorEl.textContent = 'Wall widths and height must be greater than 0.';
        }
        return null;
      }
    }

    let rollWidthInches;
    let rollLengthFeet;
    let verticalRepeatInches;
    let matchType;

    if (inputs && inputs.rollData) {
      rollWidthInches = Number(inputs.rollData.roll_width) || 0;
      rollLengthFeet = Number(inputs.rollData.roll_length) || 0;
      verticalRepeatInches = Number(inputs.rollData.vertical_repeat) || 0;
      matchType = (inputs.rollData.match_type || '').toLowerCase();

      // Last-resort fallback: parse dimensions from size/title text such as
      // "Roll (24in x 9ft)" when structured roll data is missing.
      if (!rollWidthInches || !rollLengthFeet) {
        const label = (inputs.rollData.size || inputs.rollData.title || '');
        const parsed = parseRollDimensionsFromLabel(label);
        if (parsed) {
          if (!rollWidthInches) rollWidthInches = parsed.rollWidthInches;
          if (!rollLengthFeet) rollLengthFeet = parsed.rollLengthFeet;
        }
      }
    }

    if ((!rollWidthInches || !rollLengthFeet) && inputs && inputs.rollLabel) {
      const parsedFromLabel = parseRollDimensionsFromLabel(inputs.rollLabel);
      if (parsedFromLabel) {
        if (!rollWidthInches) rollWidthInches = parsedFromLabel.rollWidthInches;
        if (!rollLengthFeet) rollLengthFeet = parsedFromLabel.rollLengthFeet;
      }
    }

    if (!rollWidthInches || !rollLengthFeet) {
      console.warn('DbWallpaperCalculator: missing roll width/length variant data.');
      if (errorEl) {
        errorEl.textContent = 'Wallpaper roll information is not available for this product.';
      }
      return null;
    }

    const trimAllowance = 4; // inches
    const rollLengthInches = rollLengthFeet * 12;

    let effectiveRepeat = verticalRepeatInches > 0 ? verticalRepeatInches : 0;
    if (effectiveRepeat > 0 && matchType === 'half-drop') {
      effectiveRepeat = effectiveRepeat * 2;
    }

    const effectiveWallWidths = wallWidthsInches.map(function (width) {
      return width + trimAllowance;
    });
    let panelsNeeded = 0;
    effectiveWallWidths.forEach(function (effectiveWidth) {
      panelsNeeded += Math.ceil(effectiveWidth / rollWidthInches);
    });

    let panelLength;
    if (effectiveRepeat > 0) {
      panelLength = Math.ceil(wallHeight / effectiveRepeat) * effectiveRepeat + trimAllowance;
    } else {
      panelLength = wallHeight + trimAllowance;
    }

    const panelsPerRoll = Math.floor(rollLengthInches / panelLength);

    if (panelsPerRoll <= 0) {
      console.warn('DbWallpaperCalculator: roll is shorter than one panel.', {
        rollLengthInches: rollLengthInches,
        panelLength: panelLength
      });
      if (errorEl) {
        errorEl.textContent = 'Selected roll size cannot cover this wall height. Select a longer roll size from the dropdown.';
      }
      return null;
    }

    let rollsNeeded = Math.ceil(panelsNeeded / panelsPerRoll);

    if (resultEl) {
      resultEl.textContent = '';
      const stack = document.createElement('span');
      stack.className = 'db-calc-result__stack';

      const primaryLine = document.createElement('span');
      primaryLine.className = 'db-calc-result__line db-calc-result__line--primary';
      primaryLine.appendChild(document.createTextNode('Estimated rolls needed: '));
      const rollsStrong = document.createElement('strong');
      rollsStrong.className = 'db-calc-result__rolls';
      rollsStrong.textContent = rollsNeeded + (rollsNeeded === 1 ? ' Roll' : ' Rolls');
      primaryLine.appendChild(rollsStrong);
      if (rollWidthInches > 0 && rollLengthFeet > 0) {
        const dimSpan = document.createElement('span');
        dimSpan.className = 'db-calc-result__roll-dim';
        dimSpan.textContent = ' (' + rollWidthInches + '" × ' + rollLengthFeet + ' ft)';
        primaryLine.appendChild(dimSpan);
      }

      const detailLine = document.createElement('span');
      detailLine.className = 'db-calc-result__line db-calc-result__line--detail';
      detailLine.textContent =
        'Based on ' + panelsNeeded + (panelsNeeded === 1 ? ' panel.' : ' panels.');

      const bleedLine = document.createElement('span');
      bleedLine.className = 'db-calc-result__line db-calc-result__line--detail';
      bleedLine.textContent = 'Includes 4" installation allowance for width and height (trim and wall alignment).';

      stack.appendChild(primaryLine);
      stack.appendChild(detailLine);
      stack.appendChild(bleedLine);
      resultEl.appendChild(stack);
    }

    console.log('DbWallpaperCalculator result:', {
      wallWidthsInches: wallWidthsInches,
      effectiveWallWidthsInches: effectiveWallWidths,
      wallHeightInches: wallHeight,
      rollWidthInches: rollWidthInches,
      rollLengthInches: rollLengthInches,
      verticalRepeatInches: verticalRepeatInches,
      matchType: matchType,
      panelsNeeded: panelsNeeded,
      panelLength: panelLength,
      panelsPerRoll: panelsPerRoll,
      rollsNeeded: rollsNeeded
    });
    return { rollsNeeded: rollsNeeded };
  }

  function parseRollDimensionsFromLabel(label) {
    if (!label) return null;

    const text = String(label).toLowerCase();
    const match = text.match(/(\d+(?:\.\d+)?)\s*in\s*x\s*(\d+(?:\.\d+)?)\s*ft/);
    if (!match) return null;

    const rollWidthInches = Number(match[1]) || 0;
    const rollLengthFeet = Number(match[2]) || 0;
    if (!rollWidthInches || !rollLengthFeet) return null;

    return {
      rollWidthInches: rollWidthInches,
      rollLengthFeet: rollLengthFeet
    };
  }
});

